module.exports = __webpack_public_path__ + "static/2019-DIY-as-Privilege-02d1f4ceb112a4f2419c521c4d159f9e.pdf";